// extracted by mini-css-extract-plugin
module.exports = {"breadCrumb2":"BreadCrumb-module__breadCrumb2"};